import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Progress } from 'antd';
import AbacusView from '../../base/abacus';
import Result from '../../base/result';
import { checkiOSVersion, generateRandomNumberSeries } from '../../../utils';
import './index.less';
import { t } from '../../../languages';
import ExerciseBlocker from '../../Utils/ExerciseBlocker';
import NumPad from '../../Utils/NumPad';
import { motion } from 'framer-motion';
import ChangeOrientation from '../../Utils/ChangeOrientation';
import moment from 'moment';
import BackMusic from '../../base/BackMusic';
import { getRandomMessage2 } from '../utils';

const WhatNumberIs = (props) => {
    const [state, setState] = useState({
        eid: 0,
        series: [],
        current: 0,
        results: [],
        times: [],
        numberinbox: null,
        message: null,
        showresults: false,
        moved: 0,
    });
    const [initMoment, setInitMoment] = useState(0);

    useEffect(() => {
        setInitMoment(moment());
        handleRepeat();
    }, []);

    const handleRate = () => {
        const { current, series, results, numberinbox } = state;
        const currentNumber = series[current];
        const current_result = currentNumber === numberinbox ? 1 : 0;
        const message = current_result
            ? t(props.lang, 'rightanswer')
            : `${t(props.lang, 'yourwrong')} ${currentNumber}`;
        const message2 = current_result
            ? t(props.lang, getRandomMessage2('great'))
            : t(props.lang, getRandomMessage2('nodiscorage'));

        setState((prevState) => ({
            ...prevState,
            results: [...results, current_result],
            message,
            message2,
        }));
    };

    const handleNext = () => {
        const { current, series, results } = state;
        if (current < series.length - 1) {
            setState((prevState) => ({
                ...prevState,
                current: current + 1,
                numberinbox: null,
                message: null,
                message2: null,
                moved: 0,
            }));
        } else {
            const { params, uid, eid, saveResult } = props;
            const num = params.num;
            const hits = results.reduce((acc, aR) => acc + aR, 0);
            const errors = num - hits;
            const passed = errors > params.errors ? 0 : 1;
            const coins = params.coins;
            const elapsedTime = moment().diff(initMoment, 'seconds');

            saveResult(uid, `${uid}-${eid}`, { id: 'WN', uid, eid, p: passed, h: hits, e: errors, c: passed ? coins : 0, r: results, s: series, et: elapsedTime });

            setState((prevState) => ({
                ...prevState,
                showresults: true,
            }));
        }
    };

    const handleRepeat = () => {
        const { params } = props;
        let series = [];
        const configSeries = params.series;

        if (configSeries) {
            for (let idx = 0; idx < configSeries.length; idx++) {
                const aSerie = configSeries[idx];
                series = series.concat(
                    generateRandomNumberSeries(aSerie.num, aSerie.init, aSerie.finish, null)
                );
            }
        } else {
            series = params
                ? generateRandomNumberSeries(params.num, params.init, params.finish, null)
                : generateRandomNumberSeries(9, 1, 9, null);
        }

        setState({
            series,
            current: 0,
            numberinbox: 0,
            results: [],
            message: null,
            message2: null,
            showresults: false,
            moved: 0,
        });
    };

    const handleChange = (val) => {
        setState((prevState) => ({
            ...prevState,
            numberinbox: parseInt(val),
            moved: 1,
        }));
    };

    const {
        current,
        series,
        results,
        message,
        message2,
        showresults,
        moved,
        numberinbox,
    } = state;

    const currentNumber = series[current];
    const rate = results[current];
    const messagestyle = message ? (!rate ? ' error' : ' valid') : '';
    const percent = Math.round((current / props.params.num) * 100);

    const is_test = props.params.is_test ? props.params.is_test : false;
    const stillrows = Array.from(Array(props.params.rows).keys());

    const params = {
        ...props.params,
        rows: props.params ? props.params.rows : 1,
        number: currentNumber,
        stillrows,
    };

    const iOSVer = checkiOSVersion();
    const scaleTpApply = iOSVer === 0 || iOSVer > 14 ? 2 : 1;

    if (!showresults) {
        return (
            <Row className="exercise">
                <BackMusic source={'random'} />

                <ChangeOrientation to={'portrait'} />

                {!is_test ? (
                    <Col span={21} className="progress-bar">
                        <Progress percent={percent} showInfo={false} />
                    </Col>
                ) : null}

                <Col span={24} className="exercise-body">
                    <section className="whatnumberis">
                        <ExerciseBlocker show={messagestyle} />
                        <article className="abacus-cover animated bounceIn" key={currentNumber}>
                            <motion.div
                                animate={{ scale: scaleTpApply }}
                                transition={{ duration: 1 }}
                                className="the-number"
                            >
                                <AbacusView
                                    params={params}
                                    isactive={false}
                                    hidelatframe={true}
                                    hideheaderlabels={true}
                                />
                            </motion.div>
                        </article>
                        <Row className="input-number">
                            <Col span={24}>
                                <NumPad
                                    clickHandler={(val) => handleChange(val)}
                                    clear={!moved}
                                />
                            </Col>
                        </Row>
                    </section>
                </Col>
                <Col span={24}>
                    <Row className={'botones' + messagestyle}>
                        <Col span={24} className={'message'}>
                            {message}
                        </Col>
                        {!message ? (
                            <Col span={24}>
                                <Button
                                    key="submit"
                                    type="primary"
                                    onClick={handleRate}
                                    style={{ width: '90%' }}
                                    disabled={!moved}
                                >
                                    {t(props.lang, 'grade')}
                                </Button>
                            </Col>
                        ) : null}
                        {message ? (
                            <Col span={24}>
                                <Button
                                    key="submit"
                                    type="primary"
                                    onClick={handleNext}
                                    style={{ width: '90%' }}
                                >
                                    {t(props.lang, 'next')}
                                </Button>
                            </Col>
                        ) : null}
                        {message2 ? (
                            <Col span={24} className={'message'}>
                                {message2}
                            </Col>
                        ) : null}
                    </Row>
                </Col>
            </Row>
        );
    } else {
        const lParams = { ...props.params };
        lParams.num = results.length;

        return (
            <Result
                params={lParams}
                results={results}
                handleRepeat={handleRepeat}
                handleCancel={props.handleCancel}
                lang={props.lang}
            />
        );
    }
};

export default WhatNumberIs;